import { v4 as uuidv4 } from 'uuid';

export function StickyLayout(props = {}, childrenComponents = []) {
	return {
		componentName: 'StickyLayout',
		componentId: uuidv4(),
		props: Object.assign(
			{
				blockClass: 'sticky-header',
				position: 'top',
				verticalSpacing: 0,
			},
			props,
		),
		childrenComponents,
	};
}
